"use strict";

import {
     authConstants,
     commonConstants,
     responseCodes,
     factTableConstants,
} from "../_constants";

export const INITIAL_FACT_TABLE_STATE = {
     list: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },
     types: [],
     labels: [],
     schemeAttribute: [],
     schemaType: [],
     details: {},
     tableValueList: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     tableValueDetails: { attributeList: [] },
     manageDataValues: {
          data: [],
          totalPageCount: 0,
          totalRecords: 0,
     },

     dataSchema: {},
     dataRowDetails: {},
};

export function factTable(state = INITIAL_FACT_TABLE_STATE, action) {
     switch (action.type) {
          /**
           * Customer login
           */

          case factTableConstants.FACT_TABLE_LIST_COMPLETE:
               return {
                    ...state,
                    list: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case factTableConstants.FACT_TABLE_TYPES_COMPLETE:
               return {
                    ...state,
                    types: [...action.payload],
               };

          case factTableConstants.FACT_TABLE_LABELS_COMPLETE:
               return {
                    ...state,
                    labels: [...action.payload],
               };

          case factTableConstants.FACT_TABLE_GET_COMPLETE:
               return {
                    ...state,
                    details: { ...action.payload },
               };

          case factTableConstants.FACT_TABLE_SCHEMA_VALUE_LIST_COMPLETE:
               return {
                    ...state,
                    tableValueList: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case factTableConstants.FACT_TABLE_SCHEMA_VALUE_GET_COMPLETE:
               return {
                    ...state,
                    tableValueDetails: { ...action.payload },
               };

          case factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_COMPLETE:
               return {
                    ...state,
                    schemeAttribute: [...action.payload],
               };

          case factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_TYPE_COMPLETE:
               return {
                    ...state,
                    schemaType: [...action.payload],
               };

          case factTableConstants.FACT_TABLE_GET_VALUE_COMPLETE:
               return {
                    ...state,
                    manageDataValues: {
                         data: [...action.payload.recordsList],
                         totalPageCount: action.payload.totalPageCount,
                         totalRecords: action.payload.totalRecords,
                    },
               };

          case factTableConstants.GET_FACT_TABLE_JSON_SCHEMA_COMPLETE:
               return {
                    ...state,
                    dataSchema: {
                         ...action.payload,
                    },
               };

          case factTableConstants.GET_FACT_TABLE_SCHEMA_RECORD_COMPLETE:
               return {
                    ...state,
                    dataRowDetails: {
                         ...action.payload.dataObject,
                    },
               };
     }

     return state;
}
